import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconInfoSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconInfoSimple"><Circle cx="12" cy="5.5" r="1.5" fill="currentColor"/><Path d="M9.75 10.25H11C11.5523 10.25 12 10.6977 12 11.25V19.25M12 19.25H9.75M12 19.25H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconInfoSimple;
